import "@/App.css";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Specialties } from "@/components/Specialties";
import { HighlightsCarousel } from "@/components/HighlightsCarousel";
import { Menu } from "@/components/Menu";
import { Gallery } from "@/components/Gallery";
import { Nosotros } from "@/components/Nosotros";
import { Location } from "@/components/Location";
import { PlatformsSocial } from "@/components/PlatformsSocial";
import { SocialSection } from "@/components/SocialSection";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { FloatingCart } from "@/components/FloatingCart";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <SmoothScroll />
        <Header />
        <main>
          <Hero />
          <Specialties />
          <HighlightsCarousel />
          <Menu />
          <Gallery />
          <Nosotros />
          <PlatformsSocial />
          <Location />
          <SocialSection />
          <FinalCTA />
        </main>
        <Footer />
        <FloatingCart />
        <CartDrawer />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }}
        />
      </div>
    </CartProvider>
  );
}

export default App;
